import request from './httpService';

const BASE = '/print-templates';

export const PrintTemplateService = {
  /**
   * List templates for the current tenant.
   * @param {string} [documentType] - optional filter
   */
  list: (documentType) =>
    request({ url: BASE, method: 'GET', params: documentType ? { documentType } : {} }),

  /** Get a single template by id */
  getById: (id) =>
    request({ url: `${BASE}/${id}`, method: 'GET' }),

  /**
   * Returns the full token catalog grouped by document type and category.
   * Used by the template editor to show available {{tokens}}.
   */
  getTokenCatalog: () =>
    request({ url: `${BASE}/token-catalog`, method: 'GET' }),

  /** Create a new template */
  create: (data) =>
    request({ url: BASE, method: 'POST', data }),

  /** Update a tenant-owned template */
  update: (id, data) =>
    request({ url: `${BASE}/${id}`, method: 'PUT', data }),

  /** Hard-delete a template */
  remove: (id) =>
    request({ url: `${BASE}/${id}`, method: 'DELETE' }),

  /** Set a template as the default for its document type */
  setDefault: (id) =>
    request({ url: `${BASE}/${id}/set-default`, method: 'POST' }),

  /** Clone a system template into an editable tenant copy */
  clone: (id) =>
    request({ url: `${BASE}/${id}/clone`, method: 'POST' }),

  /**
   * Request a preview PDF.
   * Returns a Blob, which the caller can open via URL.createObjectURL.
   * @param {string} id       - template id
   * @param {number} [recordId] - optional real record to populate the preview
   */
  preview: (id, recordId) =>
    request({
      url: `${BASE}/${id}/preview`,
      method: 'POST',
      data: recordId ? { recordId } : {},
      responseType: 'blob',
    }),
};
